var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Alternate Map Marker\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.1786 13.0496C0.654195 7.94022 0 7.41585 0 5.53809C0 2.96596 2.0851 0.880859 4.65723 0.880859C7.22935 0.880859 9.31445 2.96596 9.31445 5.53809C9.31445 7.41585 8.66026 7.94022 5.13585 13.0496C4.90457 13.3837 4.40986 13.3836 4.1786 13.0496ZM4.65723 7.4786C5.72895 7.4786 6.59774 6.60981 6.59774 5.53809C6.59774 4.46637 5.72895 3.59757 4.65723 3.59757C3.58551 3.59757 2.71672 4.46637 2.71672 5.53809C2.71672 6.60981 3.58551 7.4786 4.65723 7.4786Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoction);
export default __webpack_public_path__ + "static/media/loction.37b9f47237ddeb9f1128d65540865e30.svg";
export { ForwardRef as ReactComponent };